import React, { useState } from "react";
import moment from "moment";
import { isEmpty } from "lodash";
import OutsideClickHandler from "react-outside-click-handler";

const CalendarWeb = ({ setFilter, onCancel, fromPeriod, toPeriod }) => {
  const today = moment();

  const [leftMonth, setLeftMonth] = useState(moment());
  const [rightMonth, setRightMonth] = useState(moment().add(1, "month"));

  const [mode, setMode] = useState("start");
  const [startDate, setStartDate] = useState(
    !isEmpty(fromPeriod)
      ? moment(fromPeriod).startOf("day")
      : moment().startOf("day")
  );
  const [endDate, setEndDate] = useState(
    !isEmpty(toPeriod)
      ? moment(toPeriod).startOf("day")
      : moment().startOf("day")
  );

  const generateDays = (month) => {
    const days = [];
    const daysInMonth = month.daysInMonth();
    const firstDay = month.clone().startOf("month").day();
    const previousMonthDays = month.clone().subtract(1, "month").daysInMonth();

    // prev month filler
    for (let i = 0; i < firstDay; i++) {
      days.push({
        value: month
          .clone()
          .subtract(1, "month")
          .date(previousMonthDays - firstDay + i + 1),
        disabled: true,
      });
    }

    // current month
    for (let i = 1; i <= daysInMonth; i++) {
      const d = month.clone().date(i);
      days.push({
        value: d,
        disabled: d.isAfter(today, "day"),
      });
    }

    // next filler
    while (days.length < 42) {
      days.push({
        value: month
          .clone()
          .add(1, "month")
          .date(days.length - (daysInMonth + firstDay) + 1),
        disabled: true,
      });
    }

    return days;
  };

  const handleDayClick = (day) => {
    if (day.disabled) return;

    if (mode === "start") {
      setStartDate(day.value.clone().startOf("day"));
      setEndDate(day.value.clone().endOf("day"));
      setMode("end");
    } else {
      let finalStart = startDate;
      let finalEnd;

      if (day.value.isBefore(startDate, "day")) {
        finalStart = day.value.clone().startOf("day");
        finalEnd = day.value.clone().endOf("day");
      } else {
        finalEnd = day.value.clone().endOf("day");
      }

      setStartDate(finalStart);
      setEndDate(finalEnd);
      setMode("start");

      // // 🔥 CLOSE MODAL IMMEDIATELY
      // onApply(finalStart, finalEnd);
      setFilter((prev) => {
        return {
          ...prev,
          fromPeriod: finalStart,
          toPeriod: finalEnd,
        };
      });
      onCancel();
    }
  };
  const renderCalendar = (month, type) => {
    const days = generateDays(month);
    return (
      <div className="calendar-table">
        <table className="table-condensed">
          <thead>
            <tr>
              {" "}
              {type == "left" ? (
                <th
                  onClick={() => {
                    setLeftMonth((m) => m.clone().subtract(1, "month"));
                    setRightMonth((m) => m.clone().subtract(1, "month"));
                  }}
                  className="prev available"
                >
                  <span />
                </th>
              ) : (
                <th></th>
              )}
              <th colSpan={7} className="month">
                {month.format("YYYY / MM")}
              </th>
              {type == "right" ? (
                <th
                  className={`next ${
                    leftMonth.isSameOrAfter(today, "month")
                      ? "disabled"
                      : "available"
                  }`}
                  onClick={() => {
                    if (leftMonth.isBefore(today, "month")) {
                      setLeftMonth((m) => m.clone().add(1, "month"));
                      setRightMonth((m) => m.clone().add(1, "month"));
                    }
                  }}
                >
                  <span></span>
                </th>
              ) : (
                <th></th>
              )}
            </tr>
            <tr>
              {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
                <th key={d}>{d}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {Array.from({ length: 6 }).map((_, r) => (
              <tr key={r}>
                {days.slice(r * 7, r * 7 + 7).map((day, i) => {
                  const isStart = day.value.isSame(startDate, "day");
                  const isEnd = day.value.isSame(endDate, "day");
                  const isBetween =
                    day.value.isAfter(startDate, "day") &&
                    day.value.isBefore(endDate, "day");

                  return (
                    <td
                      key={i}
                      className={`
                        ${day.disabled ? "off disabled" : "available"}
                        ${isStart ? "start-date active" : ""}
                        ${isEnd ? "end-date active" : ""}
                        ${isBetween ? "in-range" : ""}
                      `}
                      onClick={() => handleDayClick(day)}
                    >
                      {day.value.date()}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <OutsideClickHandler onOutsideClick={onCancel}>
      <div
        style={{
          top: "45.3667px",
          left: "303.433px",
          right: "auto",
          display: "block",
        }}
        className="daterangepicker ltr auto-apply show-calendar opensright"
      >
        {/* LEFT CALENDAR */}
        <div className="drp-calendar left">
          {/* <div
          className="prev available"
          onClick={() => {
            setLeftMonth((m) => m.clone().subtract(1, "month"));
            setRightMonth((m) => m.clone().subtract(1, "month"));
          }}
        >
          ‹
        </div> */}
          {renderCalendar(leftMonth, "left")}
        </div>

        {/* RIGHT CALENDAR */}
        <div className="drp-calendar right">
          {/* <div
          className={`next ${
            leftMonth.isSameOrAfter(today, "month") ? "disabled" : "available"
          }`}
          onClick={() => {
            if (leftMonth.isBefore(today, "month")) {
              setLeftMonth((m) => m.clone().add(1, "month"));
              setRightMonth((m) => m.clone().add(1, "month"));
            }
          }}
        >
          ›
        </div> */}
          {renderCalendar(rightMonth, "right")}
        </div>

        {/* FOOTER */}
        <div className="drp-buttons">
          <span className="drp-selected">
            {startDate.format("MM/DD")} ~ {endDate.format("MM/DD")}
          </span>

          <button className="cancelBtn" onClick={onCancel}>
            Cancel
          </button>

          <button
            className="applyBtn"
            onClick={() =>
              setFilter((prev) => {
                return {
                  ...prev,
                  fromPeriod: startDate,
                  toPeriod: endDate,
                };
              })
            }
          >
            Apply
          </button>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default CalendarWeb;
